import { withInRange } from '../../common/utils/helper';
import { ColumnBase } from './column-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * The `RangeColumnSeries` module is used to render the range column series.
 */
export class RangeColumnSeries extends ColumnBase {
    constructor() {
        super(...arguments);
        this.sideBySideInfo = [];
    }
    /**
     * Renders the Range Column series.
     *
     * @param {Series} series - The series to render.
     * @returns {void}
     * @private
     */
    render(series) {
        this.sideBySideInfo[series.index] = this.getSideBySideInfo(series);
        //let origin: number = Math.max(<number>series.yAxis.visibleRange.min, 0);
        for (const rangePoint of series.points) {
            this.renderPoint(series, rangePoint, this.sideBySideInfo[series.index]);
        }
        this.renderMarker(series);
    }
    renderPoint(series, rangePoint, sideBySideInfo) {
        let rect;
        rangePoint.symbolLocations = [];
        rangePoint.regions = [];
        if (rangePoint.visible && withInRange(series.points[rangePoint.index - 1], rangePoint, series.points[rangePoint.index + 1], series)) {
            rect = this.getRectangle(rangePoint.xValue + sideBySideInfo.start, rangePoint.high, rangePoint.xValue + sideBySideInfo.end, rangePoint.low, series);
            rect.width = series.columnWidthInPixel ? series.columnWidthInPixel : rect.width;
            if (series.columnWidthInPixel) {
                if (series.chart.columns.length === 1) {
                    const rectCount = isNullOrUndefined(series.rectCount) ? 0 : series.rectCount;
                    rect.x =
                        rect.x - (((series.columnWidthInPixel / 2) * rectCount) -
                            (series.columnWidthInPixel * (rectCount - (isNullOrUndefined(series.position) ? 0 : series.position) - 1))) +
                            (series.chart.enableSideBySidePlacement ? 0 : (series.columnWidthInPixel / 2));
                }
                else {
                    rect.x = rect.x + rect.width / 2 - series.columnWidthInPixel;
                }
            }
            const argsData = this.triggerEvent(series, rangePoint, series.interior, { width: series.border.width, color: series.border.color });
            if (!argsData.cancel) {
                this.updateSymbolLocation(rangePoint, rect, series);
                this.drawRectangle(series, rangePoint, rect, argsData);
            }
        }
    }
    updateDirection(series, point) {
        for (let i = 0; i < point.length; i++) {
            this.renderPoint(series, series.points[point[i]], this.sideBySideInfo[series.index]);
            if (series.marker && series.marker.visible) {
                series.points[point[i]].symbolLocations.map((location, index) => {
                    series.chart.markerRender.renderMarker(series, series.points[point[i]], location, index, true);
                });
            }
            if (series.marker.dataLabel.visible && series.chart.dataLabelModule) {
                series.chart.dataLabelModule.commonId = series.chart.element.id + '_Series_' + series.index + '_Point_';
                series.chart.dataLabelModule.renderDataLabel(series, series.points[point[i]], null, series.marker.dataLabel);
            }
        }
    }
    /**
     * Get module name.
     *
     * @returns {string} - Returns the module name.
     */
    getModuleName() {
        return 'RangeColumnSeries';
        /**
         * return the module name.
         */
    }
    /**
     * Animates the series.
     *
     * @param  {Series} series - Defines the series to animate.
     * @returns {void}
     * @private
     */
    doAnimation(series) {
        this.animate(series);
    }
    /**
     * To destroy the range column series.
     *
     * @returns {void}
     * @private
     */
    destroy() {
        /**
         * Destroy method performed here.
         */
    }
}
